import { Stack, Tooltip, Typography, useTheme } from "@mui/material/index";
import { CircleRounded } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CBDossierKindKeys, ScoreInfo } from "../../../types";

interface CBScoreCustomFieldsInfoProps {
    field: ScoreInfo,
    currentKind: string | null
}
const CBScoreCustomFieldsInfo = ({field, currentKind }: CBScoreCustomFieldsInfoProps) => {

    const theme = useTheme();
    const { t } = useTranslation('customerbase');

    const [properties, setProperties] = useState({
        icon: <></>,
        name: '',
        value: ''
    });

    const chooseIcon = (status: string | null) => {
        var color = theme.palette.grey.A400;

        if(!!status)
            switch(status) {
                case "OK":
                    color = theme.palette.success.main;
                    break;
                case "WARNING":
                    color = theme.palette.warning.main;
                    break;
                case "KO":
                    color = theme.palette.error.main;
                    break;
                default:
                    color = theme.palette.grey.A400;
                    break;
            }

        return <CircleRounded sx={{color: color}} fontSize="small"/>

    }

    useEffect(() => {
        setProperties({
            name: field.name,
            icon: chooseIcon(field.score),
            value: field.value
        })

    }, [field]);

    return (
        <Stack direction={"row"} columnGap={1} alignItems={"center"} justifyContent={"flex-start"}>
            <Typography  variant="body1">{t(`${properties.name}`)}</Typography>
            <Tooltip 
                title={currentKind == CBDossierKindKeys.SELFIE ? '' : (!!properties.value ? t("labels.value") + ": " + properties.value : t("labels.dataNotAvailable"))} 
                arrow
            >
                {properties.icon}
            </Tooltip>
        </Stack>
        
    )

}

export default CBScoreCustomFieldsInfo;